const ColumnsFibre = [
    { field: 'Area_Industriale', headerName: 'Area_Industriale', width: 230, sortable:false },
    { field: 'plusCODE', headerName: 'plusCODE', width: 230, sortable:false },
    { field: 'Citta', headerName: 'Citta', width: 230, sortable:false },
    { field: 'Indirizzo', headerName: 'Indirizzo', width: 230, sortable:false },
    { field: 'Numero_Civico', headerName: 'Numero_Civico', width: 230, sortable:false },
    { field: 'Id', headerName: 'Id', width: 30, sortable:false },

];
export default ColumnsFibre;